<template>
    <div class="wrapper">
        <div class="title">{{videoTitle}}</div>
        <div class="view-num">播放次数：{{viewNum}}</div>
        <div class="time">发布时间：{{time.replace(/-/g, '/').slice(0, 16)}}</div>
    </div>
</template>

<script>
    export default {
        props: {
            videoTitle: {
                type: String
            },
            viewNum: {
                type: Number
            },
            time: {
                type: String
            }
        }
    }
</script>

<style scoped>
.wrapper {
    text-align: left;
    padding: 8px 12px;
    font-size: 14px;
    line-height: 1.5;
}
.title {
    font-size: 16px;
    font-weight: 600;
}
</style>